// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M5.4 1.8H10.6C11.29 1.8 11.85 2.36 11.85 3.05C11.85 3.74 11.29 4.3 10.6 4.3H5.4C4.71 4.3 4.15 3.74 4.15 3.05C4.15 2.36 4.71 1.8 5.4 1.8Z',
  'M5.65 4.3L5.92 7.12C5.98 7.7 5.72 8.25 5.26 8.6L3.77 9.75C3.39 10.04 3.2 10.48 3.2 10.96C3.2 11.31 3.49 11.6 3.85 11.6H12.15C12.51 11.6 12.8 11.31 12.8 10.96C12.8 10.48 12.61 10.04 12.23 9.75L10.74 8.6C10.28 8.25 10.02 7.7 10.08 7.12L10.35 4.3',
  'M8 11.6V14.4',
];
